import React, { useState } from 'react';
import {
  withStyles,
  FormControl,
  FormLabel,
  FormGroup,
  Typography,
  Fab,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import CreateIcon from '@material-ui/icons/Create';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import PF2MSearchSelectOutlined from '~/components/PF2MSearchSelectOutlined';
import PF2MButton from '~/components/PF2MButton';
import {
  Card,
  CardBody,
  CardHeader,
  CardIcon,
} from '~/components/Card';
import {
  updateTruckAllocations,
  deallocateTruckAllocations,
  updateIsTruckAllocationLoading,
} from '~/store/dispatch/actions';
import classnames from 'classnames';
import styles from '../../styles';
import withModal, { ModalDefaultProps, ModalPropTypes } from '~/components/PF2MModal/withModal';


const TruckAllocationModal = React.forwardRef(({ closeModal, classes }, _ref) => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const loadAllocations = useSelector(
    state => state.dispatch.loadAllocations.filter(r => r.priority),
  );
  const selectedTruckAllocation = useSelector(state => state.dispatch.selectedTruckAllocation);
  const [selectedLoadAllocationId, setSelectedLoadAllocationId] = useState(
    selectedTruckAllocation?.load_allocation_id || 0,
  );

  const renderHeader = () => (
    <div>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
      >
        {`${translate('common:EquipmentAllocation')}: ${selectedTruckAllocation.equip_name}`}
      </Typography>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridColumnGap: 10,
        gridRowGap: 10,
      }}
      >
        <div>
          <span className={classes.labelTypeSelector}>
            {`${translate('common:EquipmentType')}:`}
          </span>
          <span style={{ paddingLeft: 10, color: '#647886' }}>
            {selectedTruckAllocation.equip_type_name}
          </span>
        </div>
        <div>
          <span className={classes.labelTypeSelector}>
            {`${translate('common:EquipmentGroup')}:`}
          </span>
          <span style={{ paddingLeft: 10, color: '#647886' }}>
            {selectedTruckAllocation.equip_group_name}
          </span>
        </div>
        <div>
          <span className={classes.labelTypeSelector}>
            {`${translate('common:Equipment')}:`}
          </span>
          <span style={{ paddingLeft: 10, color: '#647886' }}>
            {selectedTruckAllocation.equip_name}
          </span>
        </div>
        <div>
          <span className={classes.labelTypeSelector}>
            {`${translate('common:Status')}:`}
          </span>
          <span style={{ paddingLeft: 10, color: '#647886' }}>
            {selectedTruckAllocation.status}
          </span>
        </div>
      </div>
    </div>
  );

  const onSave = () => {
    dispatch(updateTruckAllocations({
      item: selectedTruckAllocation,
      key: 'load_allocation_id',
      value: selectedLoadAllocationId,
      skipLoading: true,
      dispatchLoading: true,
    }));
    closeModal();
  };
  return (
    <div style={{ width: 600 }}>
      <Card>
        <CardHeader icon>
          <>
            <CardIcon color="warning">
              <CreateIcon />
            </CardIcon>
            <CardIcon
              onClick={() => {
                dispatch(updateIsTruckAllocationLoading(false));
                closeModal();
              }}
              style={{
                float: 'right',
                cursor: 'pointer',
                background: 'darkgray',
                borderRadius: 50,
                boxShadow: '10px 10px 50px gray',
              }}
            >
              <CloseIcon />
            </CardIcon>
          </>
        </CardHeader>
        <CardBody>
          <div />
          <div>
            {renderHeader()}
            <hr />
            <div>
              <div style={{
                display: 'flex',
                marginTop: 10,
                width: '100%',
              }}
              >
                <FormControl>
                  <FormLabel className={classes.formLabel}>
                    {translate('common:AllocateTo')}
                  </FormLabel>
                  <FormGroup>
                    <PF2MSearchSelectOutlined
                      placeholder={null}
                      className={classnames(classes.field)}
                      value={selectedLoadAllocationId}
                      onChange={e => setSelectedLoadAllocationId(e.target.value)}
                    >
                      {[{ value: 0, label: translate('common:Select') }]
                        .concat(loadAllocations
                          .map(e => ({ value: e.id, label: e.equip_name })))}
                    </PF2MSearchSelectOutlined>
                  </FormGroup>
                </FormControl>
              </div>
              <div style={{
                display: 'flex',
                marginTop: 10,
                alignItems: 'center',
                justifyContent: 'center',
              }}
              >
                {!!selectedTruckAllocation.id && (
                  <PF2MButton
                    color="primary"
                    onClick={() => {
                      dispatch(deallocateTruckAllocations({ id: selectedTruckAllocation.id }));
                      closeModal();
                    }}
                  >
                    <DeleteOutline className={classes.icon} />
                    {translate('common:DeleteAllocation')}
                  </PF2MButton>
                )}
                <Fab
                  variant="extended"
                  size="medium"
                  color="secondary"
                  onClick={onSave}
                  className={classes.saveButton}
                >
                  <SaveIcon className={classes.icon} />
                  {translate('common:Save')}
                </Fab>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
});

TruckAllocationModal.propTypes = {
  ...ModalPropTypes,
};

TruckAllocationModal.defaultProps = {
  ...ModalDefaultProps,
};

export default withModal(withStyles(styles)(TruckAllocationModal));
